module.exports = {
  title: 'React Native Skia Bottom Sheet Animation 📜',
  author: 'Enzo Manuel Mangano',
  date: '2023-04-12',
  slug: 'skia-bottom-sheet',
  tags: ['skia'],
};
